module.exports = __webpack_public_path__ + "img/xz.cb4a475a.jpg";